import React from 'react';
import { Hero } from '../components/Hero';
import { LocalTrust } from '../components/LocalTrust';
import { Services } from '../components/Services';
import { HowItWorks } from '../components/HowItWorks';
import { FAQ } from '../components/FAQ';
import { Reviews } from '../components/Reviews';
export function Home() {
  return <main data-id="element-1475">
      <Hero data-id="element-1476" />
      <LocalTrust data-id="element-1477" />
      <Services data-id="element-1478" />
      <HowItWorks data-id="element-1479" />
      <FAQ data-id="element-1480" />
      <Reviews data-id="element-1481" />
    </main>;
}